import * as React from 'react';
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@material-ui/lab';
import { toggleButtonGroupRoot } from './toggleButtonGroupCssDefs';

interface ToggleButtonGroupStyleProps {
  fullWidth?: boolean;
}

export type ToggleButtonGroupProps = ToggleButtonGroupStyleProps & MuiToggleButtonGroupProps;
/**
 * Component to group related options
 *
 * Demo:
 * [Storybook](http://tock-assets.tocktix.com/styleguide/dashboard/?path=/docs/components-togglebuttongroup--playground)
 *
 * Related Components: ui/ToggleButton, ui/ToggleIconButton
 * @deprecated Deprecated — use pantry SegmentedControl instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-segmentedcontrol--docs
 */
export const ToggleButtonGroup: React.FunctionComponent<
  React.PropsWithChildren<ToggleButtonGroupProps>
> = ({ className, fullWidth, ...props }) => {
  return (
    <MuiToggleButtonGroup className={className} css={toggleButtonGroupRoot(fullWidth)} {...props} />
  );
};
